var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9941_92770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4487 4.73852C12.3186 5.56277 12.9557 6.65724 13.0024 7.8735C13.0218 9.2043 12.7575 10.4227 11.8344 11.4352C11.7957 11.4793 11.7569 11.5235 11.7169 11.5689C10.8961 12.4487 9.74401 12.9556 8.54461 13.0171C7.1903 13.0574 5.92525 12.6012 4.93223 11.6734C4.30829 11.0589 3.9365 10.3375 3.68005 9.50928C3.66401 9.45909 3.64797 9.40889 3.63145 9.35718C3.32273 8.15837 3.6189 6.86842 4.22318 5.81872C4.3644 5.58446 4.52239 5.37776 4.7069 5.17603C4.75012 5.12746 4.79333 5.0789 4.83785 5.02886C5.54384 4.27838 6.46032 3.77281 7.48544 3.61124C7.52951 3.60387 7.57358 3.5965 7.61898 3.58891C8.9903 3.40507 10.4103 3.83075 11.4487 4.73852Z",
    fill: "#2FA551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0078125 0C5.47375 0 10.9553 0 16.603 0C16.603 5.48156 16.603 10.9631 16.603 16.6108C11.1214 16.6108 5.63986 16.6108 -0.0078125 16.6108C-0.0078125 11.1292 -0.0078125 5.64767 -0.0078125 0ZM1.07944 1.08331C1.07944 5.83003 1.07944 10.5767 1.07944 15.4673C5.82348 15.4673 10.5675 15.4673 15.4553 15.4673C15.4553 10.7206 15.4553 5.97387 15.4553 1.08331C10.7113 1.08331 5.96724 1.08331 1.07944 1.08331Z",
    fill: "#2FA551"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9941_92770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6108,
    height: 16.6108,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegIcon);
export default __webpack_public_path__ + "static/media/vegIcon.40541bb5be40d8de228f19162928d41f.svg";
export { ForwardRef as ReactComponent };